"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _config = require("../config");

var _ReportPanel = _interopRequireDefault(require("./ReportPanel"));

var _TitleBar = _interopRequireDefault(require("../components/TitleBar"));

var _sc = require("../actions/sc4");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable @typescript-eslint/camelcase */


var Report = function Report() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var deviceType = (0, _reactRedux.useSelector)(function (state) {
    return state.deviceSizeReducer.deviceSize;
  });
  var metadata = (0, _reactRedux.useSelector)(function (state) {
    var _state$metadataReduce;

    return ((_state$metadataReduce = state.metadataReducer.metadata) === null || _state$metadataReduce === void 0 ? void 0 : _state$metadataReduce.directory) || '';
  });
  var activeReport = (0, _reactRedux.useSelector)(function (state) {
    return state.reportVisibilityReducer.openReport;
  });
  var reportState = (0, _reactRedux.useSelector)(function (state) {
    return state.reportReducer;
  });
  var summary = (0, _reactRedux.useSelector)(function (state) {
    return state.summaryReducer.summary;
  });

  var reportConfig = _config.reportsConfig.find(function (report) {
    return activeReport !== undefined && report.name === activeReport;
  });

  (0, _react.useEffect)(function () {
    if (metadata && activeReport && (!reportState[activeReport] || reportState[activeReport].metadata.directory !== metadata)) {
      dispatch((0, _sc.getReport)(activeReport));
    }
  }, [dispatch, metadata, activeReport, reportState]);

  if (activeReport && summary) {
    var reportDataRaw = reportState[activeReport];

    if (reportDataRaw && reportConfig) {
      var reportData = {
        reportName: reportDataRaw.reportName,
        metadata: reportDataRaw.metadata,
        areas: reportDataRaw.file_data.areas,
        updatedAt: summary.date_generated,
        totals: {
          cust_a: summary.total_cust_a,
          cust_s: summary.total_cust_s
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        id: 'report-panel-container'
      }, /*#__PURE__*/_react.default.createElement(_TitleBar.default, {
        deviceType: deviceType,
        title: reportConfig.title,
        subtitle: reportConfig.description
      }), /*#__PURE__*/_react.default.createElement(_ReportPanel.default, {
        deviceType: deviceType,
        sc5Report: reportData,
        config: reportConfig,
        updateIntervalText: summary.update_wording['EN-US']
      }));
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", null, "\xA0");
};

var _default = Report;
exports.default = _default;